var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[_vm._v(_vm._s(_vm.displayName)+_vm._s(_vm.flags ? " " : "")),(_vm.flags)?_c('PersonFlags',{attrs:{"value":_vm.value}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }